import { UserSquareIcon } from "@assets/icons"

const PatientHeader = ({ patientData }) => {
  return (
    <div className="gap-2 flex items-center mx-4 md:mx-0">
      <UserSquareIcon className="h-6 w-6 text-[var(--text-theme)]" />
      <div className="text-xs text-[--text-light-gray] font-bold tracking-widest">
        {patientData?.local?.firstName + " " + patientData?.local?.lastName ||
          "Patient Name"}
      </div>
    </div>
  )
}

export default PatientHeader
